<script setup lang="ts">
// error.vue に非同期処理 (await) は書かないこと
const showError = ref<boolean>(false);
const error = useError();
definePageMeta({
  // エラー表示におけるヘッダーは 直接この error.vue の template に記述する
  // エラー表示画面内で追加の例外発生することは避けなければならないため 内部処理がわからないヘッダーの埋め込みをしない
  layout: "empty",
  title: "Error",
  noindex: true
});
const errorMessage = computed(() => {
  return error.value?.statusCode === 404 ? "Page not found" : "An error occurred";
});
const navigateTop = async () => {
  await navigateTo({
    path: "/" // エラー画面は依存を減らしたいので getNavigationRoute を使わず直接記述する
  });
};

onMounted(async () => {
  await new Promise(resolve => setTimeout(resolve, 500));
  showError.value = true;
});
</script>

<template>
  <NuxtLayout>
    <div v-show="showError"
         class="error"
    >
      <div class="mt-5">
        <h1>{{ errorMessage }}</h1>
        <div role="button"
             @click="navigateTop"
        >
          {{ $t("GO_TO_TOP_PAGE") }}
        </div>
      </div>
    </div>
  </NuxtLayout>
</template>

<style scoped lang="scss">
.error {
  margin: 80px auto;
  width: 60vw;
  min-width: 300px;
  height: 75vh;
}
</style>
